import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import VueMeta from 'vue-meta'
import VueFormulate from '@braid/vue-formulate'

Vue.config.productionTip = false
Vue.use(VueMeta)
Vue.use(VueFormulate)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Sentry.init({
  dsn: "https://ed532192d7f54bb5a5e365322e5ec43e@o468342.ingest.sentry.io/5496765",
  integrations: [
    new Sentry.Integrations.Vue({
      Vue,
      tracing: true,
    }),
    new Sentry.Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

